import styled from 'styled-components';
import { SingleSelectMenu } from '../../../../Dropdown';
import { theme } from '../../../../../styles/theme';

export const FormRow = styled.div`
  display: flex;
  column-gap: 8px;
`;

export const OperatorMenu = styled(SingleSelectMenu)`
  width: 87px;
  flex: 0 0 87px;
`;

export const Label = styled.div`
  align-self: center;
  font-weight: 600;
  line-height: 1.5;
  color: ${theme.colors.mainBlue};
`;

export const OperandDivider = styled.div`
  flex: 0 0 auto;
  align-self: center;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;

export const ActionsContainer = styled.div`
  display: flex;
  column-gap: 16px;
  margin-top: 16px;
`;
